var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sku-table-wrapper" },
    [
      _vm.isMore && _vm.tableSelections.length
        ? _c("div", { staticClass: "title-box mb-12" }, [
            _c("div", { staticClass: "header input-item" }, [
              _vm._v(_vm._s(_vm.$t("stores::products-info::batch_edit"))),
            ]),
            _c(
              "div",
              { staticClass: "input-item" },
              [
                _c("el-input", {
                  staticClass: "item",
                  attrs: {
                    placeholder: _vm.$t("stores::products-info::first_stock"),
                    "controls-position": "right",
                    size: "mini",
                  },
                  on: {
                    change: function () {
                      return _vm.onMoreInput("skuInventory")
                    },
                  },
                  model: {
                    value: _vm.edHeader.skuInventory,
                    callback: function ($$v) {
                      _vm.$set(_vm.edHeader, "skuInventory", $$v)
                    },
                    expression: "edHeader.skuInventory",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "input-item" },
              [
                _c("el-input", {
                  staticClass: "item",
                  attrs: {
                    placeholder: _vm.$t("stores::products-info::weight"),
                    "controls-position": "right",
                    size: "mini",
                  },
                  on: {
                    change: function () {
                      return _vm.onMoreInput("weight")
                    },
                  },
                  model: {
                    value: _vm.edHeader.weight,
                    callback: function ($$v) {
                      _vm.$set(_vm.edHeader, "weight", $$v)
                    },
                    expression: "edHeader.weight",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "input-item" },
              [
                _c("el-input", {
                  staticClass: "item",
                  attrs: {
                    placeholder: _vm.$t(
                      "stores::products-info::purchase_price"
                    ),
                    "controls-position": "right",
                    size: "mini",
                  },
                  on: {
                    change: function () {
                      return _vm.onMoreInput("purchasePrice")
                    },
                  },
                  model: {
                    value: _vm.edHeader.purchasePrice,
                    callback: function ($$v) {
                      _vm.$set(_vm.edHeader, "purchasePrice", $$v)
                    },
                    expression: "edHeader.purchasePrice",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "input-item" },
              [
                _c("el-input", {
                  staticClass: "item",
                  attrs: {
                    placeholder: _vm.$t(
                      "stores::products-info::compare_at_price"
                    ),
                    "controls-position": "right",
                    size: "mini",
                  },
                  on: {
                    change: function () {
                      return _vm.onMoreInput("compareAtPrice")
                    },
                  },
                  model: {
                    value: _vm.edHeader.compareAtPrice,
                    callback: function ($$v) {
                      _vm.$set(_vm.edHeader, "compareAtPrice", $$v)
                    },
                    expression: "edHeader.compareAtPrice",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "input-item" },
              [
                _c("el-input", {
                  staticClass: "item",
                  attrs: {
                    placeholder: _vm.$t("stores::products-info::sale_price"),
                    "controls-position": "right",
                    size: "mini",
                  },
                  on: {
                    change: function () {
                      return _vm.onMoreInput("salePrice")
                    },
                  },
                  model: {
                    value: _vm.edHeader.salePrice,
                    callback: function ($$v) {
                      _vm.$set(_vm.edHeader, "salePrice", $$v)
                    },
                    expression: "edHeader.salePrice",
                  },
                }),
              ],
              1
            ),
            _c(
              "a",
              {
                on: {
                  click: function ($event) {
                    return _vm.onMoreInput()
                  },
                },
              },
              [_c("i", { staticClass: "el-icon-check refresh" })]
            ),
          ])
        : _vm._e(),
      _c(
        "ScrollsBar",
        {
          ref: "scroll",
          style: "height: " + (_vm.isMore ? "560px" : "616px") + ";",
        },
        [
          _vm.data && _vm.data.length
            ? _c(
                "div",
                { staticClass: "cell-body-wrapper" },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      on: { change: _vm.handleCheckedChange },
                      model: {
                        value: _vm.tableSelections,
                        callback: function ($$v) {
                          _vm.tableSelections = $$v
                        },
                        expression: "tableSelections",
                      },
                    },
                    _vm._l(_vm.data, function (item, index) {
                      return _c(
                        "el-checkbox",
                        {
                          key: index,
                          attrs: {
                            disabled: _vm.isMore,
                            label: item.id || item.fakeId,
                          },
                        },
                        [
                          _c("div", { staticClass: "cell-box" }, [
                            _c(
                              "div",
                              { staticClass: "cell-item" },
                              [
                                _c("el-image", {
                                  staticClass: "img-box",
                                  attrs: { src: item.imageUrl },
                                }),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "cell-item cel-sku" }, [
                              _c("div", { staticClass: "sku-title" }, [
                                _c("span", { staticClass: "title" }, [
                                  _vm._v("SKU："),
                                ]),
                                _c("span", { staticClass: "desc" }, [
                                  _vm._v(_vm._s(_vm.$dataCheck(item.id))),
                                ]),
                              ]),
                              _c(
                                "div",
                                { staticClass: "sku-content" },
                                [
                                  _c("span", { staticClass: "content-item" }, [
                                    _c("span", { staticClass: "title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "stores::products-info::safe_stock"
                                          )
                                        ) + "："
                                      ),
                                    ]),
                                    _c("span", { staticClass: "desc" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$dataCheck(item.safeInventory)
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _c("span", { staticClass: "content-item" }, [
                                    _c("span", { staticClass: "title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "stores::products-info::goods_stock"
                                          )
                                        ) + "："
                                      ),
                                    ]),
                                    _c("span", { staticClass: "desc" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$dataCheck(item.skuInventory)
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _c("span", { staticClass: "content-item" }, [
                                    _c("span", { staticClass: "title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "stores::products-info::weight"
                                          )
                                        ) + "："
                                      ),
                                    ]),
                                    _c("span", { staticClass: "desc" }, [
                                      _vm._v(
                                        _vm._s(_vm.$dataCheck(item.weight)) +
                                          _vm._s(item.weightUnit)
                                      ),
                                    ]),
                                  ]),
                                  item.options && item.options.length
                                    ? _vm._l(item.options, function (stem, si) {
                                        return _c(
                                          "span",
                                          {
                                            key: si,
                                            staticClass: "content-item",
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "title" },
                                              [_vm._v(_vm._s(stem.name) + "：")]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "desc" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$dataCheck(stem.value)
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      })
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    { staticClass: "edit-content-btn" },
                                    [
                                      _c("el-button", {
                                        staticClass: "edit-btn item-btn",
                                        attrs: {
                                          icon: "el-icon-edit",
                                          type: "primary",
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return function (e) {
                                              return _vm.onEdit(e, item, index)
                                            }.apply(null, arguments)
                                          },
                                        },
                                      }),
                                      _c("el-button", {
                                        staticClass: "copy-btn item-btn",
                                        attrs: {
                                          icon: "el-icon-copy-document",
                                          type: "primary",
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return function (e) {
                                              return _vm.onCopy(e, item, index)
                                            }.apply(null, arguments)
                                          },
                                        },
                                      }),
                                      _c("el-button", {
                                        staticClass: "item-btn",
                                        attrs: {
                                          icon: "el-icon-delete",
                                          type: "primary",
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return function (e) {
                                              return _vm.onDel(e, item, index)
                                            }.apply(null, arguments)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              ),
                              _c("div", { staticClass: "sku-fix-content" }, [
                                _c("span", { staticClass: "content-item" }, [
                                  _c("span", { staticClass: "title" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "stores::products-info::purchase_price"
                                        )
                                      ) + "(￥)："
                                    ),
                                  ]),
                                  _c("span", { staticClass: "desc" }, [
                                    _vm._v(
                                      _vm._s(_vm.$dataCheck(item.purchasePrice))
                                    ),
                                  ]),
                                ]),
                                _c("span", { staticClass: "content-item" }, [
                                  _c("span", { staticClass: "title" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "stores::products-info::compare_at_price"
                                        )
                                      ) + "(￥)："
                                    ),
                                  ]),
                                  _c("span", { staticClass: "desc" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$dataCheck(item.compareAtPrice)
                                      )
                                    ),
                                  ]),
                                ]),
                                _c("span", { staticClass: "content-item" }, [
                                  _c("span", { staticClass: "title" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "stores::products-info::sale_price"
                                        )
                                      ) + "(￥)："
                                    ),
                                  ]),
                                  _c("span", { staticClass: "desc" }, [
                                    _vm._v(
                                      _vm._s(_vm.$dataCheck(item.salePrice))
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]),
                          ]),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _c("div", { staticClass: "cell-body-wrapper" }, [
                _c("div", { staticClass: "empty-content" }, [
                  _vm._v(_vm._s(_vm.$t("system::common::btn::no_data"))),
                ]),
              ]),
        ]
      ),
      _c("skuModal", {
        ref: "skuModal",
        attrs: {
          data: _vm.data,
          drawRow: _vm.backRow,
          selectedSkuOpt: _vm.selectedSkuOpt,
        },
        on: {
          onAddAttr: function ($event) {
            return _vm.$emit("onAddAttr")
          },
          save: _vm.onSave,
        },
        model: {
          value: _vm.visable,
          callback: function ($$v) {
            _vm.visable = $$v
          },
          expression: "visable",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }